/**
 * Gets the number of fraction digits used for generation of Adyen money value. Used (copy/pasted) from the Adyen SFCC cartridge internal implementation.
 * @param {string} currencyCode is the currency type of the money object
 * @returns {Number} the number of fraction digits used for generation of Adyen money value
 */
export const getFractionDigits = (currencyCode) => {
    let format
    switch (currencyCode) {
        case 'CVE':
        case 'DJF':
        case 'GNF':
        case 'IDR':
        case 'JPY':
        case 'KMF':
        case 'KRW':
        case 'PYG':
        case 'RWF':
        case 'UGX':
        case 'VND':
        case 'VUV':
        case 'XAF':
        case 'XOF':
        case 'XPF':
            format = 0
            break
        case 'BHD':
        case 'IQD':
        case 'JOD':
        case 'KWD':
        case 'LYD':
        case 'OMR':
        case 'TND':
            format = 3
            break
        default:
            format = 2
            break
    }
    return format
}

/**
 * Transforms SFCC amount of money into Adyen money value. Used (copy/pasted) from the Adyen SFCC cartridge internal implementation.
 * @param {Number} sfccMoneyValue is the SFCC amount of money that would be transformed into Adyen money value
 * @param {string} currencyCode is the currency type of the money object
 * @returns {Number} the Adyen money value used by the API
 */
export const convertToAdyenFormat = (sfccMoneyValue, currencyCode) => {
    const digitsNumber = getFractionDigits(currencyCode)
    return Math.round(sfccMoneyValue * Math.pow(10, digitsNumber))
}

/**
 * Checks if the error triggered from Adyen component has minor priority due to Adyen transaction flow.
 * Known unsolved issue in Adyen component - https://github.com/Adyen/adyen-web/issues/2713
 * @param {Object} error - Adyen error object
 * @return {Boolean} true if the error triggered from Adyen component has minor priority
 */
export const isAdyenErrorMinor = (error) =>
    error?.message === 'secured field iframes have failed to load' ||
    error?.message?.indexOf('Internal error') != -1 ||
    error?.message?.indexOf('No ack for postMessage') != -1 ||
    error?.message?.indexOf('checkoutshopper-live.adyen.com/checkoutshopper/v1/sessions') != -1
